module.exports = __webpack_public_path__ + "static/media/heavy_pound11.14a469f1.jpg";